<div *ngIf="isLoading == true">
  Loading related items
</div>

<div *ngIf="isLoading == false">
 
  <div *ngIf="entities.length == 0">
    There are no related Lectionary Items
  </div>

  <div *ngIf="entities.length > 0">
    
    <div style="border-bottom:1px solid gray">Related Lectionary Items</div>

      <div class="table-responsive table tblGrid">
    
        <div *ngFor="let m of entities" class="gridRow row">
    
            <div>{{m.Source}} {{formatPageNumber(m.PageNumber)}}</div> 
      
        </div>

      </div>
      
  </div>


</div>